/* eslint-disable no-console */
import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class QuantitySelector extends ThemeComponent {
    @Prop min!: number;
    @Prop({default: 9999}) max!: number;
    @Prop({attr: 'value'}) private _value!: number;

    get value() {
        return this._value;
    }
    set value(value: number) {
        value = Math.min(this.max, Math.max(this.min, value));
        this._value = value;

        this.render();
        this._onChange.dispatch(value);
    }

    @Ref() decreaseButton!: HTMLButtonElement;
    @Ref() increaseButton!: HTMLButtonElement;
    @Ref() input!: HTMLInputElement;


    private _onChange = new SimpleEvent<number>();
    get onChange() {
        return this._onChange.asEvent();
    }

    init() {
        this.$listen(this.increaseButton, 'click', () => this.increment());
        this.$listen(this.decreaseButton, 'click', () => this.decrement());
        this.$listen(this.input, 'input', () => this.handleInput());
        this.render();
    }

    private handleInput() {
        this.value = Number(this.input.value) || 0;
    }

    private render() {
        this.input.value = this.value.toString();
    }

    public increment() {
        this.value++;
    }

    public decrement() {
        this.value--;
    }
}
